// 2P AI — raggruppamento stati sessione per la UI (§9). "Conclusa" = terminata; tutto il resto
// è "attiva/aperta". "Sta lavorando" (richiede conferma alla chiusura, §10) = running.
const CONCLUDED = new Set(['done', 'error', 'timeout', 'canceled']);

export function isConcluded(status: string): boolean {
  return CONCLUDED.has(status);
}

export function isOpen(status: string): boolean {
  return !CONCLUDED.has(status);
}

export function isWorking(status: string): boolean {
  return status === 'running';
}
